export default {
    url: '/licences',
    template: '<ui-view></ui-view>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/settings/licences/index.js